import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import API from "../../services/api";
import totalAssureLogo from "../../assets/totalassure.png";
import banner from "../../assets/banner.png";

function StatCounter({ target, suffix, label }) {
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    let start = 0;
    const step = Math.ceil(target / (1800 / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <div style={{ fontSize: 32, fontWeight: 800, color: "#fff", letterSpacing: "-0.02em", lineHeight: 1 }}>
        {count.toLocaleString()}{suffix}
      </div>
      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontWeight: 500, letterSpacing: "0.03em" }}>
        {label}
      </div>
    </div>
  );
}

function Login() {
  const [email, setEmail] = useState("");
 
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // NEW — OTP verification stage
  const [otpStage, setOtpStage] = useState(false);
  const [pendingEmail, setPendingEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");

  const { setUser } = useAuth();
  const navigate = useNavigate();

  /* ── ALL ORIGINAL LOGIC UNCHANGED ── */
/* ── ALL ORIGINAL LOGIC UNCHANGED, factored into completeLogin() so both
     the direct-login path (admin/manager) and the OTP-verified path
     (engineer/client) can reuse it ── */
  const completeLogin = (data) => {
    const { token, user: profileData } = data;
    console.log("LOGIN RESPONSE =", data);
    console.log("PROFILE DATA =", profileData);
    console.log("PROFILE DATA FULL =", JSON.stringify(profileData, null, 2));
    console.log("PROJECT ID =", profileData.project_id);

    localStorage.setItem("profileData", JSON.stringify(profileData));
    localStorage.setItem("user", JSON.stringify(profileData));
    localStorage.setItem("token", token);
    localStorage.setItem("role", profileData.role || "");
    localStorage.setItem("name", profileData.name || "");
    localStorage.setItem("email", profileData.email || "");
    localStorage.setItem("status", profileData.status || "");
    localStorage.setItem("id", profileData.id || "");
    localStorage.setItem("project_id", profileData.project_id ?? "");
    localStorage.setItem("manager_id", profileData.manager_id ?? "");
    localStorage.setItem("isApprover", Number(profileData.isApprover));
    localStorage.setItem("region", profileData.region || "");
    localStorage.setItem("type", profileData.dashboard_type || "");
    localStorage.setItem("is_admin", profileData.is_admin ?? 0);
    setUser(profileData);

    const is_admin = Number(profileData.is_admin);
    const type = (profileData.dashboard_type || "").toLowerCase().trim();
    const role = (profileData.role || "").toLowerCase().trim();

    if (role === "client") {
      navigate("/client-dashboard");
    } else if (is_admin === 1 || type === "admin" || role === "admin" || role === "manager") {
      navigate("/admin-dashboard");
    } else {
      navigate("/engineer");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    try {
     const response = await API.post("/auth/login", { email });
      if (response.data.success) {
        if (response.data.otpRequired) {
          // NEW — engineer/client accounts: pause here for OTP verification
          setPendingEmail(response.data.email || email.trim().toLowerCase());
          setOtp("");
          setOtpError("");
          setOtpStage(true);
          return;
        }
        completeLogin(response.data);
      }
    } catch (err) {
      setErrorMsg(err.response?.data?.message || "Portal gateway timed out or dropped transmission.");
    } finally {
      setLoading(false);
    }
  };

  // NEW — OTP verification submit
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setOtpLoading(true);
    setOtpError("");
    try {
      const response = await API.post("/auth/verify-login-otp", { email: pendingEmail, otp });
      if (response.data.success) {
        completeLogin(response.data);
      }
    } catch (err) {
      setOtpError(err.response?.data?.message || "Verification failed. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  // NEW — resend OTP by re-triggering login with the same credentials
  const handleResendOtp = async () => {
    setOtpError("");
    setOtpLoading(true);
    try {
      await API.post("/auth/login", { email: pendingEmail });
      setOtpError("");
    } catch (err) {
      setOtpError(err.response?.data?.message || "Failed to resend code.");
    } finally {
      setOtpLoading(false);
    }
  };

  return (
    <>
      <style>{`
       @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .lp-root {
          min-height: 100vh;
          width: 100%;
          display: flex;
          align-items: stretch;
          font-family: 'Montserrat', sans-serif;
          background: #0f172a;
        }

        /* ── LEFT PANEL ── */
        .lp-left {
          flex: 1.15;
          position: relative;
          overflow: hidden;
          min-height: 100vh;
        }
        .lp-left-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
        .lp-left-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            135deg,
            rgba(15, 23, 42, 0.82) 0%,
            rgba(30, 20, 60, 0.65) 45%,
            rgba(180, 50, 20, 0.45) 100%
          );
        }
        .lp-left-content {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 48px 52px;
        }
        .lp-brand-row {
          display: flex;
          align-items: center;
          gap: 14px;
        }
        .lp-brand-logo {
          height: 44px;
          object-fit: contain;
          filter: brightness(0) invert(1);
          opacity: 0.92;
        }
        .lp-brand-divider {
          width: 1px;
          height: 28px;
          background: rgba(255,255,255,0.25);
        }
        .lp-brand-name {
          font-size: 15px;
          font-weight: 600;
          color: rgba(255,255,255,0.88);
          letter-spacing: 0.01em;
        }
        .lp-bottom-copy {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .lp-tagline {
          font-size: 36px;
          font-weight: 700;
          color: #fff;
          line-height: 1.22;
          letter-spacing: -0.02em;
          max-width: 480px;
        }
        .lp-tagline span {
          color: #fb923c;
        }
        .lp-sub {
          font-size: 15px;
          color: rgba(255,255,255,0.6);
          line-height: 1.6;
          max-width: 360px;
        }
        .lp-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }
        .lp-pill {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          background: rgba(255,255,255,0.09);
          border: 1px solid rgba(255,255,255,0.16);
          border-radius: 100px;
          padding: 7px 14px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(255,255,255,0.78);
          letter-spacing: 0.01em;
        }
        .lp-pill-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #fb923c;
          flex-shrink: 0;
        }
        .lp-footer-line {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 20px;
          display: flex;
          align-items: center;
          gap: 24px;
        }
        .lp-stat {
          text-align: left;
        }
        .lp-stat-val {
          font-size: 22px;
          font-weight: 700;
          color: #fff;
          letter-spacing: -0.02em;
        }
        .lp-stat-label {
          font-size: 11px;
          color: rgba(255,255,255,0.45);
          text-transform: uppercase;
          letter-spacing: 0.06em;
          margin-top: 2px;
        }
        .lp-stat-sep {
          width: 1px;
          height: 32px;
          background: rgba(255,255,255,0.12);
        }

        /* ── RIGHT PANEL ── */
        .lp-right {
          flex: 0 0 480px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 56px 52px;
          position: relative;
        }
        .lp-form-inner {
          width: 100%;
          max-width: 360px;
          display: flex;
          flex-direction: column;
        }

        /* Logos row */
        .lp-logos-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 36px;
          padding-bottom: 28px;
          border-bottom: 1px solid #f1f5f9;
        }
        .lp-logo-ta {
          height: 38px;
          object-fit: contain;
        }
        .lp-logo-ap {
          height: 44px;
          object-fit: contain;
          max-width: 140px;
        }

        /* Heading */
        .lp-heading {
          font-size: 26px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.02em;
          line-height: 1.2;
          margin-bottom: 6px;
        }
        .lp-subheading {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 32px;
        }

        /* Error toast */
        .lp-error {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 10px;
          padding: 12px 14px;
          margin-bottom: 24px;
        }
        .lp-error-icon {
          flex-shrink: 0;
          width: 18px;
          height: 18px;
          margin-top: 1px;
          color: #dc2626;
        }
        .lp-error-text {
          font-size: 13px;
          font-weight: 500;
          color: #dc2626;
          line-height: 1.5;
        }

        /* Form */
        .lp-form { display: flex; flex-direction: column; gap: 20px; }
        .lp-field { display: flex; flex-direction: column; gap: 6px; }
        .lp-label {
          font-size: 13px;
          font-weight: 600;
          color: #374151;
          letter-spacing: 0.005em;
        }
        .lp-input-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
          height: 50px;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          background: #f8fafc;
          padding: 0 14px;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
        }
        .lp-input-wrap:focus-within {
          border-color: #f97316;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(249,115,22,0.12);
        }
        .lp-input-icon {
          flex-shrink: 0;
          color: #94a3b8;
          display: flex;
          align-items: center;
        }
        .lp-input {
          flex: 1;
          background: transparent;
          border: none;
          outline: none;
         font-size: 14px;
          font-family: 'Montserrat', sans-serif;
          color: #0f172a;
        }
        .lp-input::placeholder { color: #94a3b8; }
        .lp-eye-btn {
          background: none;
          border: none;
          cursor: pointer;
          color: #94a3b8;
          display: flex;
          align-items: center;
          padding: 0;
          flex-shrink: 0;
          transition: color 0.15s;
        }
        .lp-eye-btn:hover { color: #64748b; }

        /* Forgot */
        .lp-forgot-row {
          display: flex;
          justify-content: flex-end;
          margin-top: -4px;
        }
        .lp-forgot {
          font-size: 13px;
          font-weight: 600;
          color: #f97316;
          text-decoration: none;
          transition: color 0.15s;
        }
        .lp-forgot:hover { color: #ea6c0a; }

        /* Submit button */
        .lp-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          width: 100%;
          height: 52px;
          border-radius: 12px;
          border: none;
          background: #f97316;
          color: #fff;
         font-size: 15px;
          font-family: 'Montserrat', sans-serif;
          font-weight: 600;
          letter-spacing: 0.01em;
          cursor: pointer;
          box-shadow: 0 4px 16px rgba(249,115,22,0.28);
          transition: background 0.18s, box-shadow 0.18s, transform 0.12s, opacity 0.18s;
          margin-top: 4px;
        }
        .lp-btn:hover:not(:disabled) {
          background: #ea6c0a;
          box-shadow: 0 8px 28px rgba(249,115,22,0.38);
          transform: translateY(-1px);
        }
        .lp-btn:active:not(:disabled) {
          transform: translateY(0);
          box-shadow: 0 3px 10px rgba(249,115,22,0.22);
        }
        .lp-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        @keyframes lp-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .lp-spinner {
          width: 18px;
          height: 18px;
          animation: lp-spin 0.75s linear infinite;
        }

        /* Footer */
        .lp-form-footer {
          margin-top: 28px;
          padding-top: 22px;
          border-top: 1px solid #f1f5f9;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        }
        .lp-footer-brand {
          font-size: 11px;
          font-weight: 600;
          color: #cbd5e1;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
        }
        .lp-footer-brand-line {
          flex: 1;
          height: 1px;
          background: #f1f5f9;
        }
        .lp-security-note {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 11.5px;
          color: #94a3b8;
        }

        /* ── RESPONSIVE ── */
        @media (max-width: 1024px) {
          .lp-left { display: none; }
          .lp-right {
            flex: 1;
            padding: 40px 28px;
          }
        }
        @media (max-width: 480px) {
          .lp-right { padding: 32px 20px; align-items: flex-start; padding-top: 48px; }
          .lp-heading { font-size: 22px; }
          .lp-logos-row { margin-bottom: 28px; }
        }
      `}</style>

      <div className="lp-root">

        {/* ── LEFT: BANNER ── */}
        <div className="lp-left">
          <img src={banner} alt="" className="lp-left-img" />
          <div className="lp-left-overlay" />
          <div className="lp-left-content">

            {/* Top brand */}
            <div className="lp-brand-row">
              <img src={totalAssureLogo} alt="Total Assure" className="lp-brand-logo" />
              <div className="lp-brand-divider" />
              <span className="lp-brand-name">Enterprise Portal</span>
            </div>

            {/* Bottom copy */}
            <div className="lp-bottom-copy">
             <h1 className="lp-tagline">
                Built for Precision,<br />
                <span>Backed by Trust,</span>
                <br />Delivered with Assurance
              </h1>
             
              <p className="lp-sub" style={{ marginTop: 4 }}>
                Monitor execution, resource utilization, and project status from a single platform.
              </p>
              <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginTop: 8 }}>
  <StatCounter target={12550}  suffix="+" label="Projects" />
  <StatCounter target={115}   suffix="+" label="Cities Covered" />
  <StatCounter target={14200} suffix="+" label="Happy Customers" />
</div>
              {/* <div className="lp-footer-line">
                <div className="lp-stat">
                  <div className="lp-stat-val">256-bit</div>
                  <div className="lp-stat-label">SSL Encryption</div>
                </div>
                <div className="lp-stat-sep" />
                <div className="lp-stat">
                  <div className="lp-stat-val">99.9%</div>
                  <div className="lp-stat-label">Uptime SLA</div>
                </div>
                <div className="lp-stat-sep" />
                <div className="lp-stat">
                  <div className="lp-stat-val">Enterprise</div>
                  <div className="lp-stat-label">Grade Security</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* ── RIGHT: FORM ── */}
        <div className="lp-right">
          <div className="lp-form-inner">

            {/* Logos */}
            <div className="lp-logos-row">
              <img src={totalAssureLogo} alt="Total Assure" className="lp-logo-ta" />
              <img
                src={require("../../assets/APlogo.png")}
                alt="Asian Paints"
                className="lp-logo-ap"
              />
            </div>

            <h2 className="lp-heading">Welcome back</h2>
            <p className="lp-subheading">Sign in to your project portal</p>

            {!otpStage ? (
              <>
                {/* Error */}
                {errorMsg && (
                  <div className="lp-error">
                    <svg className="lp-error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <span className="lp-error-text">{errorMsg}</span>
                  </div>
                )}

                <form className="lp-form" onSubmit={handleSubmit}>

                  {/* Email */}
                  <div className="lp-field">
                    <label className="lp-label" htmlFor="lp-email">Email address</label>
                    <div className="lp-input-wrap">
                      <span className="lp-input-icon">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                          <rect x="2" y="4" width="20" height="16" rx="2" />
                          <path d="m2 7 10 7 10-7" />
                        </svg>
                      </span>
                      <input
                        id="lp-email"
                        className="lp-input"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="you@company.com"
                        required
                        autoComplete="email"
                      />
                    </div>
                  </div>

                

                  {/* Submit */}
                  <button type="submit" className="lp-btn" disabled={loading}>
                    {loading ? (
                      <>
                        <svg className="lp-spinner" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.28)" strokeWidth="3.5" />
                          <path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
                        </svg>
                        Signing in…
                      </>
                    ) : (
                      <>
                        Sign in
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </>
                    )}
                  </button>
                </form>
              </>
            ) : (
              // NEW — OTP verification stage
              <>
                {otpError && (
                  <div className="lp-error">
                    <svg className="lp-error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <span className="lp-error-text">{otpError}</span>
                  </div>
                )}

                <p className="lp-subheading" style={{ marginBottom: 24 }}>
                  We've sent a 6-digit verification code to <strong>{pendingEmail}</strong>
                </p>

                <form className="lp-form" onSubmit={handleOtpSubmit}>
                  <div className="lp-field">
                    <label className="lp-label" htmlFor="lp-otp">Verification code</label>
                    <div className="lp-input-wrap">
                      <input
                        id="lp-otp"
                        className="lp-input"
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        value={otp}
                        onChange={e => setOtp(e.target.value.replace(/\D/g, ""))}
                        placeholder=""
                        required
                        autoFocus
                      />
                    </div>
                  </div>

                  <button type="submit" className="lp-btn" disabled={otpLoading || otp.length === 0}>
                    {otpLoading ? "Verifying…" : "Verify & Sign in"}
                  </button>

                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                    <button
                      type="button"
                      onClick={() => { setOtpStage(false); setOtp(""); setOtpError(""); }}
                      style={{ background: "none", border: "none", color: "#64748b", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
                    >
                      ← Back to login
                    </button>
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      disabled={otpLoading}
                      style={{ background: "none", border: "none", color: "#f97316", fontSize: 13, fontWeight: 600, cursor: otpLoading ? "not-allowed" : "pointer" }}
                    >
                      Resend code
                    </button>
                  </div>
                </form>
              </>
            )}

            {/* Footer */}
            <div className="lp-form-footer">
              <div className="lp-footer-brand">
                <span className="lp-footer-brand-line" />
                Secured by Asian Paints Enterprise
                <span className="lp-footer-brand-line" />
              </div>
              <div className="lp-security-note">
               
             
              </div>
            </div>

          </div>
        </div>

      </div>
    </>
  );
}

export default Login;